<template>
  <div class="card-box">
    <b-row class="row pb-2">
            <!-- Filter -->
      <b-col cols="12" sm="12" md="5" >
        <div class="d-flex align-items-center">
          <!-- Filter Per Page -->
          <div v-if="getIsInternational" class="d-flex align-items-center gap-1 pr-3">
            <span>Moeda&nbsp;</span>

            <div>
              <b-form-select
                v-model="selectedCurrency"
                size="sm"
                :options="optionsCurrency"
                class="ml-1"
              />
            </div>
          </div>

          <span>Mostrar&nbsp;</span>
          <div>
            <b-form-select
              v-model="perPageOffers"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
          </div>
          <span>&nbsp;por página</span>
        </div>
      </b-col>
      <!-- Search -->
      <b-col cols="12" sm="12" md="7" class="d-flex justify-content-end align-items-center">
          <div id="tickets-table_filter"
            class="dataTables_filter text-md-right"
          >
            <b-form-input
              v-model="filterOffers"
              type="search"
              placeholder="Pesquisar..."
              class="form-control form-control-sm mb-2"
            ></b-form-input>
          </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div v-if="offers.length > 0 && !loading"
          class="table-responsive mb-0"
        >
          <b-table
            :items="offers"
            :fields="computedFieldsOffers"
            responsive="sm"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            sort-icon-left
            :filter-included-fields="filterOn"
          >
            <!-- Seller -->
            <template v-slot:cell(_seller)="data">
              <div class="externclass">
                <div
                  class="classification"
                  :style="setColor(data.item.seller.classification)"
                ></div>
                <p>{{ data.item.seller.name }}</p>
              </div>
              <b v-if="data.item.seller.cpf_cnpj">
                {{ data.item.seller.cpf_cnpj }}
              </b>
              <div v-if="data.item.seller.cellphone">
                <a
                  :href="`https://api.whatsapp.com/send?phone=+55${data.item.seller.cellphone.replace(
                    /[() -]/g,
                    ''
                  )}`"
                  target="_blank"
                  ><i class="fab fa-whatsapp"></i>
                  {{ data.item.seller.cellphone }}</a
                ></div
              >
              <div>{{ data.item.seller.email }}</div>
              <NewProgressBar v-if="data.item.seller.score && data.item.seller.score.total_score" :type="'SellerScore'" :valor="data.item.seller.score.total_score"/>

            </template>
            <!-- Amount -->
            <template v-slot:cell(amount)="data">
              <span v-if="data.item.offers">
                <span v-if="data.item.offers[0].local_currency !== null">
                  Preço base
                  {{ data.item.offers[0].local_currency.currency_symbol }}
                  {{ formatMoney(filterOfferDefault(data.item.offers)) }}
                  {{ filterOffer(data.item.offers) }}
                </span>
              </span>
            </template>
            <!-- Type -->
            <template v-slot:cell(type)="data">
              {{ data.value === 'TRANSACTION'
                  ? 'Valor único'
                  : 'Assinatura' }}
            </template>
            <!-- Local Currency -->
            <template v-slot:cell(currency)="data">
              <span v-if="data.item.offers[0].local_currency !== null">
                {{ filterOfferLocalCurrencyName(data.item.offers) }}
              </span>
            </template>
            <!-- Offers -->
            <template v-slot:cell(_offers)="data">
              <span v-if="data.item.offers.length > 0">{{ filterOfferName(data.item.offers) }}</span>
            </template>
            <!-- Creation Date  -->
            <template v-slot:cell(created_at)="data">
              {{ data.value | datetime }}
            </template>
            <!-- Actions -->
            <template v-slot:cell(_actions)="data">
              <div class="actions">
                <!-- Approve Offer -->
                <b-button
                  v-if="canShowActions && canEditOffers && canShowApproveOfferButton"
                  v-b-tooltip.hover title="Aprovar Oferta"
                  variant="success"
                  @click="acceptOffers(data.item.id + '/' + filterOfferId(data.item.offers))"
                >
                  <i class="fas fa-check"></i>
                </b-button>
                <!-- Disapprove Offer -->
                <b-button
                  v-if="canShowActions && canEditOffers && canShowDisapproveOfferButton"
                  v-b-tooltip.hover title="Recusar Oferta"
                  variant="danger"
                  @click="denyOffers(data.item.id + '/' + filterOfferId(data.item.offers))"
                >
                  <i class="fas fa-times"></i>
                </b-button>
                <!-- Info User and Product (opens modal already on the Offers tab) -->
                <b-button
                  v-b-tooltip.hover.noninteractive title="Informações do usuário e do produto"
                  :disabled="!canViewProductDetails"
                  variant="dark"
                  @click="detail(data.item)"
                >
                  <i class="fas fa-info-circle"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!--Pagination -->
    <div v-if="offers.length > 0" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPageOffers"
              :total-rows="totalRowsOffers"
              :per-page="perPageOffers"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <!-- Feedback Menssage -->
    <div v-if="offers.length === 0 && !loading" class="row justify-content-center">
      <div class="alert alert-primary" role="alert">
        Sem ofertas pendentes.
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import OffersService from '@services/resources/OffersService'
import Money from '@src/mixins/money'
import Access from '@src/mixins/access'
import _ from 'lodash'
import Graph from '@router/views/analysis/graph.vue';
import validAcessRoute from '@/src/utils/validAcessRoute'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import FoundSearchMixin from "@views/products/mixins/FoundSearchMixin";
import { AccessLevel } from "@views/configurations/enums/accessLevel";
import { mapGetters } from 'vuex';

var serviceOffer = OffersService.build()

export default {
  name: "TableOffers",
  components: { Graph, NewProgressBar },
  mixins: [Money, Access, FoundSearchMixin],
  props: {
    coins: {
      required: true,
      type: Array,
      default: () => []
    },
    activeTab: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      currentPageOffers: 1,
      loading: true,
      offersLoaded: false,
      fieldsOffers: [
        { key: 'id', label: 'ID', sortable: true },
        { key: '_seller', label: 'Vendedor', sortable: true },
        { key: 'name', label: 'Produto', sortable: false },
        { key: 'amount', label: 'Valor', sortable: true },
        { key: '_offers', label: 'Oferta', sortable: true },
        { key: 'type', label: 'Tipo', sortable: false },
        { key: 'currency', label: 'Moeda Local', sortable: false },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
      filterOffers: '',
      filterOn: [],
      filters: {},
      offers: [],
      products: [],
      pageOptions: [20, 50, 100],
      perPageOffers: 20,
      selectedCurrency: 0,
      optionsCurrency: [
        { value: 0, text: 'Todos' },
        { value: 1, text: 'BRL' },
        { value: 2, text: 'USD' },
        { value: 3, text: 'EUR'},
      ],
      sortBy: 'name',
      sortDesc: false,
      totalRowsOffers: 1,
      totalOffers: 0,
      // Actions Validations
      financial: validAcessRoute(['financial'], this.$store.getters.getProfile),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      attendance: validAcessRoute(['attendance'], this.$store.getters.getProfile),
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      financialAssistant: validAcessRoute(['financialAssistant'], this.$store.getters.getProfile),
      compliance: validAcessRoute(['compliance'], this.$store.getters.getProfile)
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canApproveOffer() {
      return !this.financial;
    },
    canShowApproveOfferButton() {
      if (this.useActionPermissions) return this.canApproveOffers;
      return this.canApproveOffer;
    },
    canApproveOffers() {
      return this.useActionPermissions && this.$canAction('offers_approve_button', 'editor');
    },
    canDisapproveOffers() {
      return this.useActionPermissions && this.$canAction('offers_disapprove_button', 'editor');
    },
    canShowDisapproveOfferButton() {
      if (this.useActionPermissions) return this.canDisapproveOffers;
      return this.canApproveOffer;
    },
    /**
     * Check if any action button should be shown (new permission system)
     * @return {boolean}
     */
    hasNewPermissionsForActions() {
      return this.canApproveOffers || this.canDisapproveOffers;
    },
    /**
     * Unified check if user can see actions (replaces canShowActionsSlot and canShowActionsDiv)
     * @return {boolean}
     */
    canShowActions() {
      if (this.useActionPermissions) {
        return this.hasNewPermissionsForActions;
      }
      // Legacy: combine both legacy rules - user must pass both checks
      const canSeeSlot = !this.financialAssistant || this.compliance;
      const canSeeDiv = (!this.risco && !this.attendance && !this.success) || this.compliance;
      return canSeeSlot && canSeeDiv;
    },
    /**
     * Dynamic fields that exclude _actions column when actions shouldn't be shown
     * @return {Array}
     */
    computedFieldsOffers() {
      if (this.canShowActions || this.canViewProductDetails) {
        return this.fieldsOffers;
      }
      return this.fieldsOffers.filter(field => field.key !== '_actions');
    },
    /**
     * Whether the info button (product/user details modal) may be used.
     * Mirrors the check used on the other product tables.
     * @return {boolean}
     */
    canViewProductDetails() {
      return this.$canAction('products_show_details', AccessLevel.READER)
    },
    canEditOffers() {
      if (!this.useActionPermissions) return true;
      return this.$canAction('products_edit_offers', 'editor');
    },
    ...mapGetters({
      getIsInternational: 'getIsInternational',
    }),
  },
  watch: {
    currentPageOffers() {
        this.fetchOffers()
    },
    perPageOffers() {
      this.fetchOffers()
    },
    filterOffers(){
      this.debounce()
    },
    activeTab(val) {
      // if tab is active, fetch offers
      if (val === 'ofertas' && !this.offersLoaded) {
        this.applyFoundSearch()
        this.fetchOffers()
      }
    },
    selectedCurrency() {
      this.currentPageOffers = 1
        this.fetchOffers({})
    }
  },
  methods: {
    /**
     * Set color in style dot before seller name on table depending on seller classification
     * @param color - String
     * @return String - css style background color
     * @author Sandro Souza
     */
    setColor(type) {
      if (type) {
        if (type === 'green') {
          return 'background: #00E4A0'
        }
        if (type === 'yellow') {
          return 'background: #fff700'
        }
        if (type === 'red') {
          return 'background: #FF0A44'
        }
        if (type === 'black') {
          return 'background: #000000'
        }
      } else {
        return 'background:#c7c7c7;'
      }
    },
    /**
     * Filter table data
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    debounce: _.debounce(function () {
      this.fetchOffers()
    }, 500),
    /**
     * Brings all offers, or only filtered offers. It feed the table.
     * @param filters - Object
     * @return no return
     * @author Sandro Souza
     */
    fetchOffers(filters = {}) {
      this.loading = true
      this.offers = []
      let currencyId = this.selectedCurrency

      let data = {
        per_page: this.perPageOffers,
        page:this.filterOffers.trim() !== '' ? 1 : this.currentPageOffers
      }
      if(currencyId != null) data.currencyId = currencyId

      Object.keys(filters).forEach((key) => {
        (filters[key] == null || filters[key].length === 0)
        && delete filters[key]
      })
      data = Object.assign(data, filters)

      if (this.filterOffers.length) data.search = this.filterOffers

      serviceOffer
        .search(data)
        .then((resp) => {
          this.offers = resp.data
          this.totalRowsOffers = resp.total
          this.totalOffers = resp.total
          this.$store.dispatch(
              'updateFoundInStatuses',
              resp.found_in_status || []
          )
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.loading = false
          this.offersLoaded = false
        });
    },
    /**
     * Get offer default and return his amount
     * @param offers - Array - array of objects
     * @return String | amount
     * @author Sandro Souza
     */
    filterOfferDefault(offers) {
      if(offers.length === 0) return
      let offerDefault = offers.find(o => o.default === 1)
      return offerDefault ? offerDefault.amount : ''
    },
    /**
     * Whether an offer is awaiting moderation: PENDING (new offer) or REVISION
     * (edited, previously-approved offer being re-moderated). Mirrors the
     * back-end ProductHasOffersStatus::underModeration().
     * @param offer - Object
     * @return Boolean
     */
    isUnderModeration(offer){
      return ['PENDING', 'REVISION'].includes(offer.status)
    },
    /**
     * Get the offer under moderation and return its amount
     * @param offers - Array - array of objects
     * @return String - ''
     * @author Sandro Souza
     */
    filterOffer(offers) {
      if(offers.length === 0) return
      let offerUnderModeration = offers.find(x => this.isUnderModeration(x))
      if (!offerUnderModeration) return '| Sem nova oferta'
      const label = offerUnderModeration.status === 'REVISION' ? 'Oferta em revisão' : 'Nova Oferta'
      return '| ' + label + ' ' + this.filterOfferLocalCurrencySymbol(offers) + ' ' + this.formatMoney2(offerUnderModeration.amount)
    },
    /**
     * Get the offer under moderation and return its name
     * @param offers - Array - array of objects
     * @return String - name
     * @author Sandro Souza
     */
    filterOfferName(offers){
      if(offers.length === 0) return
      let offerUnderModeration = offers.find(x => this.isUnderModeration(x))
      return offerUnderModeration ? offerUnderModeration.name : ''
    },
    /**
     * Get the offer under moderation and return its id
     * @param offers - Array - array of objects
     * @return Number - id
     * @author Sandro Souza
     */
    filterOfferId(offers){
      if(offers.length === 0) return
      let offerUnderModeration = offers.find(x => this.isUnderModeration(x))
      return offerUnderModeration ? offerUnderModeration.id : ''
    },
    /**
     * Get the offer under moderation and return its currency name
     * @param offers - Array - array of objects
     * @return Number - id
     * @author Sandro Souza
     */
    filterOfferLocalCurrencyName(offers){
      if(offers.length === 0) return
      let offerUnderModeration = offers.find(x => this.isUnderModeration(x))
      return (offerUnderModeration && offerUnderModeration.local_currency) ? offerUnderModeration.local_currency.name : ''
    },
    /**
     * Get the offer under moderation and return its currency symbol
     * @param offers - Array - array of objects
     * @return Number - id
     * @author Sandro Souza
     */
    filterOfferLocalCurrencySymbol(offers){
      if(offers.length === 0) return
      let offerUnderModeration = offers.find(x => this.isUnderModeration(x))
      return (offerUnderModeration && offerUnderModeration.local_currency) ? offerUnderModeration.local_currency.currency_symbol : ''
    },
    /**
     * Format given value to monetary value
     * @param number - Float - amount
     * @return Float - formatted amount
     * @author Sandro Souza
     */
    formatMoney2(number) {
      if(typeof number !== 'undefined')
        return number.toLocaleString('pt-BR', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    },
    /**
     * Fires when user selects a currency. Updates table data by applying currency filter.
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    /**
     * Open SweetAlert2 to approve offer
     * @param dados - Number - id
     * @return no return
     * @author Sandro Souza
     */
    acceptOffers(dados) {
      Vue.swal({
        title: 'Aprovar oferta',
        text: 'Tem certeza que deseja aprovar essa oferta?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: dados,
            status: 'APPROVED',
          }
          serviceOffer
            .update(data)
            .then((resp) => {
              this.fetchOffers()
            })
            .catch(err => console.error(err))
        }
      })
    },
    /**
     * Open SweetAlert2 to refuse offers
     * @param dados - Number - id
     * @return no return
     * @author Sandro Souza
     */
    /**
     * Open the details modal for the selected product. Emits "open-detail" to
     * the parent (list.vue) with the product id and the id of the offer under
     * moderation shown in this row; because the Offers tab sets type='offers',
     * the modal opens already on its internal "Ofertas" tab and goes straight
     * to that offer's change history.
     * @param item - Object (product row)
     * @return no return
     */
    detail(item) {
      this.$root.$emit('bv::hide::tooltip')
      this.$emit('open-detail', {
        productId: item.id,
        offerId: this.filterOfferId(item.offers),
      })
    },
    denyOffers(dados) {
      Vue.swal({
        title: 'Atenção! A mensagem sobre a reprovação da oferta, será enviada por e-mail ao produtor',
        text: 'Tem certeza que deseja Reprovar essa oferta?',
        type: 'warning',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: dados,
            status: 'DISAPPROVED',
            reason: result.value,
          }

          serviceOffer
            .update(data)
            .then((resp) => {
              this.fetchOffers()
            })
            .catch(err => console.error(err))
        }
      })
    }
    // -----------------------------
  }
}
</script>

<style scoped>
.card-box {
  border-radius: 0 0 3px 3px;
}
</style>
